export class Preference {
  public PreferenceId = '';
  public PreferenceName = '';
  public PreferenceIsSelected = false;

  constructor() { }

  public static parse(data: any): Preference {
    const preference = new Preference();

    if (data) {
      if (data.PreferenceId || data.PreferenciaId) {
        preference.PreferenceId = data.PreferenceId || data.PreferenciaId;
      }
      if (data.PreferenceName || data.PreferenciaNombre) {
        preference.PreferenceName = data.PreferenceName || data.PreferenciaNombre;
      }
      if (data.PreferenceIsSelected) {
        preference.PreferenceIsSelected = data.PreferenceIsSelected;
      }
    }

    return preference;
  }
}
